import { COLORS, hexToRGB } from '@shared/config/colors/colors';
import { Tooltip } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 4px;
    width: fit-content;
    padding: 2px 4px;
    border-radius: 16px;
    background-color: ${COLORS.neutral_05};
`;

export const UserIcon = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    color: ${COLORS.light_primary};
    border: 0.5px solid ${hexToRGB(COLORS.black, 0.08)};
    border-radius: 100px;
`;

export const StyledTooltip = styled(Tooltip)`
    display: flex;
    gap: 16px;
    width: fit-content;
`;

export const TooltipContent = styled('div')`
    display: flex;
    gap: 16px;
    padding: 20px;
`;

export const AvatarWrapper = styled('div')`
    position: relative;
`;

export const UserInfo = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const UserName = styled('div')`
    display: flex;
    flex-direction: column;
`;

export const UserJob = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const UserLinks = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const UserLink = styled('div')`
    display: flex;
    align-items: center;
    gap: 7px;
    color: ${COLORS.primary_60};
`;
